const GENERATED_SUBUSER_STATEMENTS_KEY = "wl_bs_subuser_statements_generated";
const SUBUSER_REPORTS_KEY = "wl_bs_subuser_reports";
const SUBUSER_STATEMENT_OVERRIDES_KEY = "wl_bs_subuser_statement_overrides";

function readJson(key, fallback) {
  if (typeof sessionStorage === "undefined") {
    return fallback;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) {
      return fallback;
    }
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // no-op
  }
}

export function clearSubuserAccountingSessionStorage() {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(GENERATED_SUBUSER_STATEMENTS_KEY);
  sessionStorage.removeItem(SUBUSER_REPORTS_KEY);
  sessionStorage.removeItem(SUBUSER_STATEMENT_OVERRIDES_KEY);
}

export function getGeneratedSubuserStatements() {
  const rows = readJson(GENERATED_SUBUSER_STATEMENTS_KEY, []);
  return Array.isArray(rows) ? rows : [];
}

export function setGeneratedSubuserStatements(rows) {
  writeJson(GENERATED_SUBUSER_STATEMENTS_KEY, Array.isArray(rows) ? rows : []);
}

export function getSubuserReportsMap() {
  const map = readJson(SUBUSER_REPORTS_KEY, {});
  return map && typeof map === "object" && !Array.isArray(map) ? map : {};
}

export function upsertSubuserReport(statementId, patch) {
  if (statementId == null || !patch || typeof patch !== "object") {
    return;
  }
  const sid = String(statementId);
  const reports = getSubuserReportsMap();
  reports[sid] = { ...(reports[sid] || {}), ...patch };
  writeJson(SUBUSER_REPORTS_KEY, reports);
}

export function getSubuserStatementOverridesMap() {
  const map = readJson(SUBUSER_STATEMENT_OVERRIDES_KEY, {});
  return map && typeof map === "object" && !Array.isArray(map) ? map : {};
}

export function upsertSubuserStatementOverride(id, patch) {
  if (id == null || !patch || typeof patch !== "object") {
    return;
  }
  const sid = String(id);
  const overrides = getSubuserStatementOverridesMap();
  overrides[sid] = { ...(overrides[sid] || {}), ...patch };
  writeJson(SUBUSER_STATEMENT_OVERRIDES_KEY, overrides);
}
